import { render, staticRenderFns } from "./ViolationsSection.vue?vue&type=template&id=4844cfcc&scoped=true"
import script from "./ViolationsSection.vue?vue&type=script&lang=js"
export * from "./ViolationsSection.vue?vue&type=script&lang=js"
import style0 from "./ViolationsSection.vue?vue&type=style&index=0&id=4844cfcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4844cfcc",
  null
  
)

export default component.exports